module.exports = __webpack_public_path__ + "static/img/MacBookPro15.1f5b8c33.png";